import { ChevronLeftIcon } from '../../components/ui/icons';
import { ListingHeaderActions } from '../../components/features/listings/ListingHeaderActions';
import * as styles from './desktopStickyHeader.styles';

type DesktopStickyHeaderProps = {
  backHref: string;
  onBackClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  backLabel?: string;
};

export const DesktopStickyHeader = ({ backHref, onBackClick, backLabel }: DesktopStickyHeaderProps) => {
  const label = backLabel ?? 'Back to search';
  const ariaLabel = backLabel ?? 'Back to search results';

  return (
    <header className={styles.desktopHeader}>
      <div className={styles.desktopHeaderColumns}>
        <a href={backHref} onClick={onBackClick} className={styles.backButton} aria-label={ariaLabel}>
          <ChevronLeftIcon />
          <span>{label}</span>
        </a>

        <div className={styles.desktopHeaderRight}>
          <ListingHeaderActions size="sm" showCTAs />
        </div>
      </div>
    </header>
  );
};
